export class ExtendedError extends Error {
  public statusCode: number | null
  public metadata?: Record<string, unknown> | null

  constructor(
    name: string,
    message: string,
    statusCode: number | null = null,
    metadata: Record<string, unknown> | null = null,
  ) {
    super(message)
    this.name = name
    this.statusCode = statusCode
    this.metadata = metadata

    if (Error.captureStackTrace && typeof Error.captureStackTrace === 'function') {
      Error.captureStackTrace(this, ExtendedError)
    }
  }
}
